import React, { useState, useEffect } from "react";
import { Container, ProfileContent } from "./styles";
import { useAuth } from "../../hooks/AuthContext";
import { Avatar, Button, Modal, Form, Input, Upload, Space } from "antd";
import { UserOutlined, UploadOutlined, LogoutOutlined, EditOutlined } from "@ant-design/icons";
import api from "../../services/api";
import { toast } from "react-toastify";

export default function Profile() {
  const { user, signOut, editUser } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (user && isModalOpen) {
      form.setFieldsValue({
        name: user.name,
        email: user.email,
      });
    }
  }, [user, isModalOpen, form]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setFileList([]);
  };

  const handleLogout = () => {
    signOut();
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", values.email);
      
      if (values.password) {
        formData.append("password", values.password);
      }
      if (values.old_password) {
        formData.append("old_password", values.old_password);
      }
      
      if (fileList.length > 0) {
        formData.append("avatar", fileList[0].originFileObj);
      }

      const response = await api.put("/user", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
      });

      toast.success("Perfil atualizado com sucesso!");
      editUser({ user: response.data });
      
      setIsModalOpen(false);
      form.resetFields();
      setFileList([]);
      
    } catch (error) {
      console.error("Error updating profile:", error);
      const errorMessage = error.response?.data?.message || "Erro ao atualizar perfil. Tente novamente.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const uploadProps = {
    onRemove: (file) => {
      setFileList([]);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false; 
    },
    fileList,
    maxCount: 1,
    listType: "picture",
  };

  return (
    <Container>
      <h1>Meu Perfil</h1>
      
      <ProfileContent>
        <div className="avatar-container">
          <Avatar 
            size={100} 
            src={user?.avatar_url || user?.photo_url} 
            icon={<UserOutlined />} 
            alt={user?.name}
          />
        </div>
        
        <div className="info-container">
          <h2>{user?.name}</h2>
          <p>{user?.email}</p>
        </div>

        <div className="actions">
          <Space size="middle">
            <Button 
              type="primary" 
              icon={<EditOutlined />} 
              onClick={showModal}
            >
              Editar Dados
            </Button>
            <Button 
              danger 
              icon={<LogoutOutlined />} 
              onClick={handleLogout}
            >
              Sair
            </Button>
          </Space>
        </div>
      </ProfileContent>

      <Modal
        title="Editar Dados do Perfil"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            name: user?.name,
            email: user?.email,
          }}
        >
            <Form.Item
              label="Nome"
              name="name"
              rules={[{ required: true, message: 'Por favor, insira seu nome!' }]}
            >
              <Input placeholder="Seu nome" />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Por favor, insira seu email!' },
                { type: 'email', message: 'Email inválido!' }
              ]}
            >
              <Input placeholder="Seu email" />
            </Form.Item>

            <Form.Item
              label="Foto de Perfil"
              name="avatar"
              valuePropName="fileList"
              getValueFromEvent={normFile}
            >
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined />}>Selecionar Foto</Button>
              </Upload>
            </Form.Item>

            <Form.Item
              label="Senha Atual"
              name="old_password"
              help="Preencha apenas se desejar alterar a senha"
            >
              <Input.Password placeholder="Sua senha atual" />
            </Form.Item>

            <Form.Item
              label="Nova Senha"
              name="password"
              dependencies={['old_password']}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('old_password')) {
                      return Promise.resolve();
                    }
                     // If there is value but no old_password, it depends on backend validation.
                     // Usually old password is required to change password.
                     // But let's just leave it optional here and let backend validate.
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Sua nova senha" />
            </Form.Item>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
            <Button key="back" onClick={handleCancel} style={{ marginRight: 10 }}>
              Cancelar
            </Button>
            <Button key="submit" type="primary" htmlType="submit" loading={loading}>
              Salvar Alterações
            </Button>
          </div>
        </Form>
      </Modal>
    </Container>
  );
}
